import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { OUTPUT_TAB } from '../../../common/constants'

import { $requestToken } from '../../../../../utils/apis'
import { getIJoistManufacturer, skipGAEventAction } from '../../../../../utils/actions'
import { LOADING, MEMBER_MANUFACTURER_PRODUCTS } from '../../../../../utils/constants'

export const triggerCalculationAction = createAction('app/triggerCalculation')

const fetchUIInitialization = createAsyncThunk(
  'request/uiInitialization',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      await $requestToken()
      await dispatch(getIJoistManufacturer({ member: MEMBER_MANUFACTURER_PRODUCTS.JOIST }))
      dispatch(triggerCalculationAction())
    } catch (error) {
      rejectWithValue(error)
    }
  },
)

export const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    loading: LOADING.PENDING,
    ecMode: false,
    manufacturerData: null,
    graphicsData: null,
    activeTab: OUTPUT_TAB.RESULT,
    canSkipGAEvent: false,
  },
  reducers: {
    modifyUIState: (state, action) => {
      state[action.payload.name] = action.payload.value
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setGraphicsData: (state, action) => {
      state.graphicsData = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUIInitialization.pending, (state) => {
      state.loading = LOADING.PENDING
    })
    // TODO: Handle initial UI load rejected
    builder.addCase(fetchUIInitialization.rejected, (state) => {
      state.loading = LOADING.FAILED
    })
    builder.addCase(fetchUIInitialization.fulfilled, (state) => {
      state.loading = LOADING.SUCCEEDED
    })
    builder.addCase(getIJoistManufacturer.fulfilled, (state, action) => {
      state.manufacturerData = action.payload
    }),
    builder.addCase(skipGAEventAction, (state, action) => {
      state.canSkipGAEvent = action.payload
    })
  },
})

export const uiActions = { ...uiSlice.actions, fetchUIInitialization }
